import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {
  hasAiCreationAccess,
  hasContentCreationPlanAccess,
} from "src/app/shared/utils/plan.util";
import {
  isTrialActive,
  isTrialGuideLimitReached,
  trialAllowsGuidePacks,
} from "src/app/shared/utils/trial.util";
import { openTrialUpgradeDialog } from "src/app/shared/utils/trial-gate.util";

@Component({
  selector: "app-bundledialog",
  templateUrl: "./bundledialog.component.html",
  styleUrls: ["./bundledialog.component.scss"],
})
export class BundledialogComponent implements OnInit {
  userData: any;

  constructor(
    private router: Router,
    private location: Location,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<BundledialogComponent>
  ) {}

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    if (!this.userData) {
      this.dialogRef.close();
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
      return;
    }
  }

  get isTrial(): boolean {
    return isTrialActive();
  }

  get aiCreationLocked(): boolean {
    return !hasAiCreationAccess(this.userData);
  }

  get guidePacksLocked(): boolean {
    return !trialAllowsGuidePacks();
  }

  private requireContentPlanOrRedirect(): boolean {
    if (hasContentCreationPlanAccess(this.userData)) {
      return true;
    }
    this.toastr.info(
      "A Creator or Business plan is required to create flows and bundles.",
      "Subscription required"
    );
    this.dialogRef.close();
    this.router.navigate(["/pricing"]);
    return false;
  }

  private openTrialGate(feature: "trial-ai" | "trial-guide-packs" | "trial-guides"): void {
    this.dialogRef.close();
    openTrialUpgradeDialog(this.dialog, feature, this.router.url);
  }

  private clearFlowDraftStorage(): void {
    localStorage.removeItem("ItemsRequired");
    localStorage.removeItem("flowCoverPageDetails");
    localStorage.removeItem("SupportingDocumentDocuments");
    localStorage.removeItem("SupportingDocumentHyperLinksRequired");
    localStorage.removeItem("stepsCoverPageDetails");
    localStorage.removeItem("draftWord");
    localStorage.removeItem("editWord");
  }

  private setCreateFlowNavigateBack(): void {
    const currentPath = this.location.path();
    localStorage.setItem("navigatebackfromcreateflow", currentPath);
    localStorage.setItem("navigatebackfromcreatebundle", currentPath);
  }

  navigateToSmartCreate(event?: Event) {
    this.navigateToQuickCreate(event);
  }

  /** @deprecated Use navigateToSmartCreate */
  navigateToQuickCreate(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.requireContentPlanOrRedirect()) {
      return;
    }

    if (this.aiCreationLocked) {
      this.openTrialGate("trial-ai");
      return;
    }

    this.setCreateFlowNavigateBack();
    this.clearFlowDraftStorage();
    this.dialogRef.close("quick-create");
  }

  navigateToManualCreate(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.requireContentPlanOrRedirect()) {
      return;
    }

    if (isTrialGuideLimitReached()) {
      this.openTrialGate("trial-guides");
      return;
    }

    this.setCreateFlowNavigateBack();
    this.clearFlowDraftStorage();
    this.dialogRef.close("manual-create");
  }

  bundle() {
    if (this.userData === null) {
      this.router.navigate(["/login"], {
        queryParams: { returnUrl: this.router.url },
      });
      return;
    }

    if (!this.requireContentPlanOrRedirect()) {
      return;
    }

    if (this.guidePacksLocked) {
      this.openTrialGate("trial-guide-packs");
      return;
    }

    this.dialogRef.close("bundle");
  }
}
